(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6384],{

/***/ 56384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content068": function() { return /* binding */ Content068; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content068_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10133);
/* harmony import */ var _Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content068 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var content = (ref1 = payload === null || payload === void 0 ? void 0 : payload.content) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var format = (ref2 = payload === null || payload === void 0 ? void 0 : payload.format) !== null && ref2 !== void 0 ? ref2 : null;
    var isNarrow = format === "narrow";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), " ").concat(isNarrow ? (_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default().narrow) : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading4 */ .k8, {
                        className: (_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        color: "dark",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                        value: content,
                        className: (_Content068_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content068);


/***/ }),

/***/ 10133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Content068_title__C7wJv","content":"Content068_content__YWdzo","narrow":"Content068_narrow__lc_F_","wrapper":"Content068_wrapper__UiPyE"};

/***/ })

}]);